import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  containerMobile: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 80,
    justifyContent: 'space-between',
    boxShadow: '0px 2px 4px rgba(36, 55, 143, 0.2)',
    backgroundColor: '#fff',
    paddingLeft: 24,
    paddingRight: 24,
    position: 'relative',
    top: 0,
    zIndex: 5
  },
  fixedContainer: {
    width: '100%',
    position: 'fixed',
    height: 92,
    top: 0,
    zIndex: 100
  },
  switcher: {
    position: 'absolute',
    top: 100,
    right: 10
  },
  switcherMobile: {
    position: 'absolute',
    top: 90,
    right: 0
  },
  toggleContainer: {
    display: 'flex',
    alignItems: 'center'
  }
}))

export default useStyles
